export class Config {
    public url_base = "https://auth4b3-cloud-pf-engine-dev.internalenv.corp"
    public redirect_url = "http://localhost:4200"
    public client_id = "CREDCARB_CLIENT";
    public response_type = "code";
    public grant_type = "authorization_code";
    public policy = "01AUTHSIMPLE";
}